class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.updateCartBtn();
    window.addEventListener('resize', () => {
      let cartBtn = document.querySelector('custom-header .cart-btn');
      if(window.innerWidth < 1024 ) {
        cartBtn.classList.remove('has-submenu');
      }
      else {
        if(!cartBtn.classList.contains('has-submenu')) {
          cartBtn.classList.add('has-submenu');
        }
      }
    });
    this.init();
    this.addEventListeners();
  }
  updateCartBtn = () => {
    let cartBtn = this.querySelector('.cart-btn');
    if(window.innerWidth < 1024 ) {
      cartBtn.classList.remove('has-submenu');
    }
    else {
      if(!cartBtn.classList.contains('has-submenu')) {
        cartBtn.classList.add('has-submenu');
      }
    }
  };
  init = () => {
    const dropDownContainerClass = ".top-menu-bg";
    this.SELECTORS = {
      hasSubmenu: "has-submenu",
      topLevelLinks: ".top-link",
      iconsLinks: ".nav-icons > a:not(.mobile-cart-btn), .nav-icons > button",
      cover: ".cover",
      openMenu: "open-menu",
      closeMenu: ".close-menu",
      dropDownContainer: dropDownContainerClass,
      mobileTopLinks: `${dropDownContainerClass} .top-link.has-submenu`,
      logo: `.logo`,
      backButton: ".menu-back-button",
    };
    this.delay = 300;
    this.breakpointMobile = 1024;
    this.lastScrollTop = window.scrollY;
    this.nav = this.querySelector("nav");
    this.topLinks = [
      ...this.nav.querySelectorAll(this.SELECTORS.topLevelLinks),
      ...this.querySelectorAll(this.SELECTORS.iconsLinks),
    ];
    this.cover = this.querySelector(this.SELECTORS.cover);
    this.closeMenu = [...this.querySelectorAll(this.SELECTORS.closeMenu)];
    this.allLinks = [...this.querySelectorAll("a")];
    this.mobileTopLinks = [
      ...this.querySelectorAll(this.SELECTORS.mobileTopLinks),
    ];
    this.dropDownContainer = this.querySelector(
      this.SELECTORS.dropDownContainer
    );
    this.logo = this.querySelector(this.SELECTORS.logo);
    this.backButton = this.querySelector(this.SELECTORS.backButton);
    this.cartAccountText = this.querySelector('#account-msg');
  };
  addEventListeners = () => {
    window.addEventListener("scroll", this.scrollHandler);
    this.closeMenu.map((el) =>
      el.addEventListener("click", this.removeTopLinkHover)
    );
    this.topLinks.map((link) => {
      link.addEventListener("mouseenter", this.topLinkHover);
      link.addEventListener("keydown", this.topLinkHover);
      link.addEventListener("mouseleave", this.topLinkHoverLeave);
      link.addEventListener("click", this.topLinkClick, true);
    });
    this.allLinks.map((link) => {
      link.addEventListener("mouseenter", this.linkHover);
      link.addEventListener("keydown", this.linkHover);
      link.addEventListener("mouseleave", this.linkHoverLeave);
      link.addEventListener("click", this.linkClick, true);
    });
    this.mobileTopLinks.map((link) => {
      link.addEventListener("click", this.mobileTopLinkClick, true);
    });
    this.backButton.addEventListener("click", this.backButtonClick);
    document.addEventListener("hideheader", () => {
      this.hideHeader();
      this.hideLogo();
    });
    document.addEventListener("showheader", () => {
      this.showHeader();
      this.showLogo();
    });
  };
  backButtonClick = () => {
    this.backButton.classList.remove("show");
    this.querySelector("li.show-submenu")?.classList.remove("show-submenu");
    this.removeHover(this.closest("nav"));
  };
  scrollHandler = () => {
    if(document.body.classList.contains("remove-scrollbar"))return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.lastScrollTop) {
      this.hideHeader();
    } else {
      this.showHeader();
    }
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    if (scrollTop === 0) {
      document.body.classList.remove("scrolldown");
    } else {
      document.body.classList.add("scrolldown");
    }
  };
  hideHeader = () => {
    document.body.classList.remove("remove-scrollbar");
    this.nav.classList.remove("top-submenu-shown");
    this.removeTopLinkHover();
  };
  showHeader = () => {
    this.showLogo();
  };
  hideLogo = () => {
    this.logo.classList.add("hide");
  };
  showLogo = () => {
    this.logo.classList.remove("hide");
  };
  topLinkHover = (e) => {
    if (e.type === "keydown" && e.code !== "Enter") return;
    if (window.innerWidth >= this.breakpointMobile) {
      this.topLinkTrigger(e, this.delay);
    }
  };
  topLinkClick = (e) => {
    e.stopPropagation();
    if (window.innerWidth < this.breakpointMobile && !e.currentTarget.classList.contains("to-account-page")) {
      const eventSource = e.currentTarget;
      if (this.nav.classList.contains("top-submenu-shown")) {
        if (eventSource.classList.contains(this.SELECTORS.openMenu)) {
          this.topLinkTrigger(e, 0, eventSource);
          this.nav.classList.toggle("menu-shown");
          document.body.classList.toggle("mobile-menu-open");
        } else {
          this.nav.classList.remove("menu-shown");
          document.body.classList.remove("mobile-menu-open");
        }
      } else {
        this.topLinkTrigger(e, 0, eventSource);
        if (eventSource.classList.contains(this.SELECTORS.openMenu)) {
          this.nav.classList.add("menu-shown");
          document.body.classList.add("mobile-menu-open");
        }
      }
    }
  };
  topLinkTrigger = (e, delay, eventSource) => {
    eventSource = eventSource || e.target;
    const func = () => {
      if (eventSource.classList.contains(this.SELECTORS.hasSubmenu)) {
        this.removeHover(this);
        if (e.type === "click") {
          if (this.nav.classList.contains("top-submenu-shown"))
            this.backButtonClick(e);
          this.nav.classList.toggle("top-submenu-shown");
          document.body.classList.toggle("remove-scrollbar");
        } else {
          this.nav.classList.add("top-submenu-shown");
          document.body.classList.add("remove-scrollbar");
        }
      } else {
        this.removeTopLinkHover(e);
      }
    };
    if (!delay) func();
    else this.toLevelHoverTimeout = setTimeout(func, delay);
  };
  topLinkHoverLeave = (e) => {
    if (window.innerWidth >= this.breakpointMobile) {
      this.toLevelHoverTimeout && clearTimeout(this.toLevelHoverTimeout);
    }
  };
  setHovered = (el, isHovered) => {
    isHovered ? el.classList.add("hovered") : el.classList.remove("hovered");
    isHovered ? el.closest('li')?.classList.add("hovered") : el.closest('li')?.classList.remove("hovered");
    let aria = el.getAttribute("aria-expanded");
    if (aria != null) el.setAttribute("aria-expanded", isHovered);
  };
  removeTopLinkHover = () => {
    this.allLinks.forEach((el) => {
      this.setHovered(el, false);
    });
    document.body.classList.remove("remove-scrollbar");
    this.nav.classList.remove("top-submenu-shown");
    this.nav.classList.remove("menu-shown");
    this.backButtonClick();
  };
  linkHover = (e) => {
    if (e.type === "keydown" && e.code !== "Enter") return;
    if (window.innerWidth >= this.breakpointMobile) {
      this.hoverTimeout = setTimeout(() => {
        const dataId = `[data-id="${e.target.dataset.id}"]`;
        const allLinksWithId = this.querySelectorAll(dataId);
        allLinksWithId.forEach((el) => {
          if (e.target.classList.contains(this.SELECTORS.hasSubmenu)) {
            this.removeHover(el.closest("ul"));
          }
          this.setHovered(el, true);
        });
      }, this.delay);
    }
  };
  linkHoverLeave = (e) => {
    this.hoverTimeout && clearTimeout(this.hoverTimeout);
  };
  removeHover = (element) => {
    element = element || this;
    const currentLevelChildLinks = [...element.querySelectorAll("a")];
    currentLevelChildLinks.map((el) => {
      this.setHovered(el, false);
    });
  };
  linkClick = (e) => {
    if (e.currentTarget.classList.contains("has-submenu")) {
      if(window.innerWidth >= this.breakpointMobile) {
        e.preventDefault();
      }
      else {
        if(!e.currentTarget.classList.contains("to-account-page")) {
          e.preventDefault();
          if (e.currentTarget.classList.contains("hovered")) {
            this.removeHover(e.currentTarget.closest("ul"));
          } else {
            this.removeHover(e.currentTarget.closest("ul"));
            const dataId = `[data-id="${e.currentTarget.dataset.id}"]`;
            const allLinksWithId = this.querySelectorAll(dataId);
            allLinksWithId.forEach((el) => {
              this.removeHover(el.closest("ul"));
              this.setHovered(el, true);
            });
          }
        }
      }
    }
  };
  mobileTopLinkClick = (e) => {
    const button = this.backButton;
    button.querySelector(".text").textContent = e.currentTarget.textContent;
    button.classList.add("show");
    e.currentTarget.parentElement.classList.add("show-submenu");
  };
}

customElements.define("custom-header", CustomHeader);
